// Replace only the API origin; preserve every path segment and query parameter.
module.exports = (url) => url.replace(/^https:\/\/api\.[^/]+\//, '/api/');
